<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
========================================================================================== -->


<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        data() {
            return {}
        },
        // created: function () {
        //     this.$http.interceptors.response.use(undefined, function (err) {
        //         return new Promise(function (resolve, reject) {
        //             if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
        //                 this.$store.dispatch(logout)
        //             }
        //             throw err;
        //         });
        //     });
        // },
        mounted() {
            document.body.classList.add('theme-semi-dark');
        },
    }
</script>
